import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { APP_INITIALIZER, Injector, NgModule } from "@angular/core";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { DelonACLModule } from "@delon/acl";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
//#region http Interceptors
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from "@angular/common/http";
// import { ComponentModule } from '@root/component/component.module';

//#region Register Language
import { registerLocaleData } from "@angular/common";
import zh from "@angular/common/locales/zh";
//#region Startup Service
import { StartupService } from "./startup.service";
import { MockInterceptor } from "@root/shared/interceptor/mock.interceptor";
import { EmptyParamsInterceptor } from "@root/shared/interceptor/empty-params.interceptor";
import { AppPublicComponent } from "./app-public.component";
import { AppPublicRouteModule } from "./app-public-route.module";
import { ErrorInterceptor } from "./shared/interceptor/error.interceptor";

registerLocaleData(zh);
//#endregion
export function StartupServiceFactory(startupService: StartupService): () => Promise<void> {
  return () => startupService.load();
}
const APPINIT_PROVIDES = [
  StartupService,
  {
    provide: APP_INITIALIZER,
    useFactory: StartupServiceFactory,
    deps: [StartupService],
    multi: true,
  },
];
//#endregion
const INTERCEPTOR_PROVIDERS = [
  { provide: HTTP_INTERCEPTORS, useClass: MockInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: EmptyParamsInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
];
//#endregion

//#region Translate Loader
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "/app/assets/i18n/", ".json");
}
const LOADER = { provide: TranslateLoader, useFactory: createTranslateLoader, deps: [HttpClient] };
//#endregion
//#endregion

const isInternationalDomain = () => {
  return (
    location.href.indexOf("localhost") !== -1 ||
    location.href.indexOf("g.test") !== -1 ||
    location.href.indexOf("hostex.io") !== -1
  );
};

@NgModule({
  declarations: [AppPublicComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    DelonACLModule.forRoot(),
    TranslateModule.forRoot({
      loader: LOADER,
      defaultLanguage: isInternationalDomain() ? "en" : "cn",
    }),
    AppPublicRouteModule,
  ],
  providers: [...INTERCEPTOR_PROVIDERS, ...APPINIT_PROVIDES],
  bootstrap: [AppPublicComponent],
})
export class AppPublicModule {
  constructor() {}
}
